import RpIcon from "@/components/RpIcon";
import RouteConstant from "@/constant/RouteConstant";
import { VerifyOption } from "@/constant/VerifyConstant";
import { Box, Grid2, Paper, Stack, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import classes from "./css/index.module.less";
import SimpleHeader from "../components/Headers/SimpleHeader";

const SECURITY_CARDS = [
  { label: 'verify_pin', option: VerifyOption.PIN, route: RouteConstant.USER_SECURITY_PIN, icon:'lock' },
  { label: 'google_authenticator_verification', option: VerifyOption.GA, route: RouteConstant.USER_SECURITY_GA, icon:'ga' },
  { label: 'email', option: VerifyOption.EMAIL, route: RouteConstant.USER_SECURITY_EMAIL, icon:'email' },
  { label: 'mobile', option: VerifyOption.MOBILE, route: RouteConstant.USER_SECURITY_MOBILE, icon:'mobile' },
];
function SecurityIndex() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const { user } = useSelector(state => state.user);

  const _createSecurityCard = (card) => {
    return <Stack direction={'column'} onClick={() => _onCardClick(card)}>
      <div className={classes["bind-container"]}>
        <RpIcon icon={card.icon} size={30}></RpIcon>
        <span className={`${classes["bind-status"]} ${classes[_bindStatus(card).class]}`}>
          {_bindStatus(card).text}
        </span>
      </div>
      <div className={classes["bind-label"]}>
        {t(card.label)}
      </div>
    </Stack>
  }

  const _bindStatus = (card) => {
    const statusMap = {
      [VerifyOption.GA]: user?.googleBindStatus == 1 ? { text: t('bound'), class: 'bound' } : { text: t('unbound'), class: 'unbound' },
      [VerifyOption.PIN]: user?.pinset ? { text: t('verified'), class: 'bound' } : { text: t('unset'), class: 'unbound' },
      [VerifyOption.EMAIL]: user?.emailBindStatus == 1 ? { text: t('bound'), class: 'bound' } : { text: t('unbound'), class: 'unbound' },
      [VerifyOption.MOBILE]: user?.mobileBindStatus == 1 ? { text: t('bound'), class: 'bound' } : { text: t('unbound'), class: 'unbound' },
    };
    return statusMap[card.option] || { text: '', class: '' };
  };

  const _onCardClick = (card) => {
    navigate(card.route);
  }

  if (!user) return null;

  return (<>
    <SimpleHeader />
    <Box className={classes["security-wrap"]}>
      <Box className={classes["security-title-wrap"]}><div className={classes["security-title"]}>{t('security')}</div></Box>
      <Box className={classes["security-module-wrap"]}>
        <Grid2 container spacing={1}>
          {SECURITY_CARDS.map((card,index) => <Grid2 key={index} size={6}>
            <div className={classes["security-module"]}>
              {_createSecurityCard(card)}
            </div>
          </Grid2>)}
        </Grid2>
      </Box>

      <Stack className={classes["account-module-list"]} direction="row" alignItems="center" justifyContent="space-between" onClick={() => {
        navigate(RouteConstant.CHANGE_PW);
      }}>
        <Stack
          direction="row"
          alignItems="center"
          gap={0.5}
        >
          <RpIcon icon="edit" size={20}/>
          <Box className={'h6'}>{user.pwdSet == 1 ? t('update_pw') : t('set_pw')}</Box>
        </Stack>
        <RpIcon icon="arrow-right-simple" size={18}/>
      </Stack>
      <Stack className={classes["account-module-list"]} direction="row" alignItems="center" justifyContent="space-between" onClick={() => {
        navigate(RouteConstant.ACCOUNT_DELETE);
      }}>
        <Stack
          direction="row"
          alignItems="center"
          gap={0.5}
          className="color-failure"
        >
          <RpIcon icon="log_out" size={20}/>
          <Box className={'h6'}>{t('delete_account')}</Box>
        </Stack>
        <Box className="color-failure"><RpIcon icon="arrow-right-simple" size={18}/></Box>
      </Stack>
    </Box>
  </>);
}

export default SecurityIndex;
